<template>
  <a-layout-sider :width="120" class="sidebar">
    <!-- Logo -->
    <div class="logo">
      <img src="../assets/logo.png" alt="Logo" class="logo-img" @click="goHome" />
      <!-- <span class="logo-text" v-if="!collapsed">TaxAgent</span> -->
    </div>

    <!-- Menu -->
    <div class="menu-wrapper">
        <a-menu v-model:selectedKeys="selectedKeys" class="menu" mode="inline" :items="items" @click="handleClick" />
    </div>

    <!-- Footer -->
    <div class="footer">
      <p>Tax Agent</p>
      <small>© All Rights Reserved</small>
      <small>By ZST</small>
    </div>
  </a-layout-sider>
</template>

<script>
import { h, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useMenuStore } from '@/store/index';
import { SettingOutlined, UserOutlined, AppstoreOutlined } from '@ant-design/icons-vue';

export default {
  name: 'AppSidebar',
  setup() {
    const selectedKeys = ref([]);
    const openKeys = ref([]);
    const router = useRouter();
    const items = ref([]);
    const menuStore = useMenuStore();
    const menus = JSON.parse(localStorage.getItem('menu'));

    //回到首页，清空子菜单
    const goHome = () => {
      menuStore.removeAll();
      router.push('home')
    }
    const iconStyle = {
      fontSize: '20px',
      color: '#27ae60',
    };
    //渲染菜单
    items.value = menus.map(item => ({
      key: item.menuCode,
      title: item.name,
      label: item.name,
      icon: () => {
        switch (item.icon) {
          case 'SettingOutlined':
            return h(SettingOutlined, { style: iconStyle });
          case 'UserOutlined':
            return h(UserOutlined, { style: iconStyle });
          case 'AppstoreOutlined':
            return h(AppstoreOutlined, { style: iconStyle });
          // 根据需要添加更多的图标映射
          default:
            return null;
        }
      }
    }));

    //菜单跳转
    const handleClick = (menuInfo) => {
      const selectedItem = menus.find(item => item.menuCode === menuInfo.key);
      if (selectedItem && selectedItem.url) {
        //加载子菜单，默认高亮第一个子菜单
        router.push(selectedItem.url);
        const defaultSelect = Array.isArray(selectedItem.children) && selectedItem.children.length > 0
          ? selectedItem.children[0].menuCode
          : selectedItem.menuCode;
        menuStore.addAllChildren(selectedItem.children, defaultSelect);
      }
    };

    return {
      selectedKeys,
      openKeys,
      items,
      router,
      menuStore,
      handleClick,
      goHome
    };
  },
};
</script>

<style scoped>
/* Sidebar general styling */
.sidebar {
  background: rgb(240, 240, 240);
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
}

/* Logo styling */
.logo {
  text-align: center;
  padding: 10px;
  width: 90%;
  margin: auto;
  transition: transform 0.3s ease-in-out;
  /* 增加过渡时间 */
  background-color: white;
  border-radius: 5px;
}

.logo:hover {
  cursor: pointer;
}


.logo-img {
  width: 80px;
  margin-bottom: 12px;
}

/* .logo-text {
  font-size: 15px;
  font-weight: bold;
  color: #333;
} */

.logo:hover {
  transform: translateY(5px) scale(1.05);
}

.menu-wrapper {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.menu-wrapper::-webkit-scrollbar {
  width: 4px;
}

.menu-wrapper::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 2px;
}

.menu {
  background: rgb(240, 240, 240);
  text-align: center;
}

::v-deep .ant-menu-item-selected {
  background: white !important;
}

::v-deep .ant-menu-item {
  margin-top: 10px;
  height: 60px;
  padding-left: 30px;
  background: white !important;
}

::v-deep .ant-menu-item:hover {
  transform: translateY(3px) scale(1.01);
  transition: all 0.3s ease;
}

.footer {
  text-align: center;
  padding: 20px 10px;
  font-size: 12px;
  color: #888;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>